export default __webpack_public_path__ + "static/media/home-section-02.c1f5c0e1.png";